module.exports = __webpack_public_path__ + "img/kopsurat_bangun_husada_sm.26b007cd.png";